<template>
  <div class="table-footer">
    <div class="footer-left">
      <span class="total-count">총 <strong>{{ totalCount.toLocaleString() }}</strong>건</span>
    </div>
    <div class="footer-center">
    <v-pagination
        v-if="totalPages > 1"
      :model-value="currentPage"
      :length="totalPages"
        :total-visible="7"
      density="compact"
      @update:model-value="$emit('update:currentPage', $event)"
    />
    </div>
    <div class="footer-right">
    <v-select
      :model-value="itemsPerPage"
      :items="pageSizeOptions"
      variant="outlined"
      density="compact"
      hide-details
      class="page-size-select"
      @update:model-value="$emit('update:itemsPerPage', $event)"
      >
        <template v-slot:selection="{ item }">{{ item.value }}건씩</template>
      </v-select>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  totalCount: number;
  currentPage: number;
  itemsPerPage: number;
  totalPages: number;
  pageSizeOptions?: number[];
}

withDefaults(defineProps<Props>(), {
  pageSizeOptions: () => [10, 20, 50]
});

defineEmits<{
  (e: 'update:currentPage', value: number): void;
  (e: 'update:itemsPerPage', value: number): void;
}>();
</script>
